/* tslint:disable */
/*
 * Autogenerated by @creditkarma/thrift-typescript v2.0.14
 * DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
*/

import * as thrift from "thrift";
import { Int64 } from "thrift";
import * as PContact from "./../../common/models";
import * as PHeader from "./../../common/models";
export enum TWebAuthRequestStatus {
    PENDING = 0,
    SUCCESS = 1,
    REJECTED = 2
}
export interface ITAuthenticateRequestArgs {
    deviceId: string;
    verifiedPhoneNumber?: string;
    firebaseIDToken: string;
    timestamp: number | Int64;
    isTestUser?: boolean;
    product?: PHeader.TAppProduct;
    firebaseUserIdFromKeychain?: string;
}
export class TAuthenticateRequest {
    public deviceId: string;
    public verifiedPhoneNumber?: string;
    public firebaseIDToken: string;
    public timestamp: Int64;
    public isTestUser?: boolean;
    public product?: PHeader.TAppProduct;
    public firebaseUserIdFromKeychain?: string;
    constructor(args: ITAuthenticateRequestArgs) {
        if (args != null && args.deviceId != null) {
            this.deviceId = args.deviceId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[deviceId] is unset!");
        }
        if (args != null && args.verifiedPhoneNumber != null) {
            this.verifiedPhoneNumber = args.verifiedPhoneNumber;
        }
        if (args != null && args.firebaseIDToken != null) {
            this.firebaseIDToken = args.firebaseIDToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[firebaseIDToken] is unset!");
        }
        if (args != null && args.timestamp != null) {
            if (typeof args.timestamp === "number") {
                this.timestamp = new Int64(args.timestamp);
            }
            else {
                this.timestamp = args.timestamp;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[timestamp] is unset!");
        }
        if (args != null && args.isTestUser != null) {
            this.isTestUser = args.isTestUser;
        }
        if (args != null && args.product != null) {
            this.product = args.product;
        }
        if (args != null && args.firebaseUserIdFromKeychain != null) {
            this.firebaseUserIdFromKeychain = args.firebaseUserIdFromKeychain;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAuthenticateRequest");
        if (this.deviceId != null) {
            output.writeFieldBegin("deviceId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.deviceId);
            output.writeFieldEnd();
        }
        if (this.verifiedPhoneNumber != null) {
            output.writeFieldBegin("verifiedPhoneNumber", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.verifiedPhoneNumber);
            output.writeFieldEnd();
        }
        if (this.firebaseIDToken != null) {
            output.writeFieldBegin("firebaseIDToken", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.firebaseIDToken);
            output.writeFieldEnd();
        }
        if (this.timestamp != null) {
            output.writeFieldBegin("timestamp", thrift.Thrift.Type.I64, 4);
            output.writeI64(this.timestamp);
            output.writeFieldEnd();
        }
        if (this.isTestUser != null) {
            output.writeFieldBegin("isTestUser", thrift.Thrift.Type.BOOL, 5);
            output.writeBool(this.isTestUser);
            output.writeFieldEnd();
        }
        if (this.product != null) {
            output.writeFieldBegin("product", thrift.Thrift.Type.I32, 6);
            output.writeI32(this.product);
            output.writeFieldEnd();
        }
        if (this.firebaseUserIdFromKeychain != null) {
            output.writeFieldBegin("firebaseUserIdFromKeychain", thrift.Thrift.Type.STRING, 7);
            output.writeString(this.firebaseUserIdFromKeychain);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAuthenticateRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_1: string = input.readString();
                        _args.deviceId = value_1;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_2: string = input.readString();
                        _args.verifiedPhoneNumber = value_2;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_3: string = input.readString();
                        _args.firebaseIDToken = value_3;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_4: Int64 = input.readI64();
                        _args.timestamp = value_4;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_5: boolean = input.readBool();
                        _args.isTestUser = value_5;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_6: PHeader.TAppProduct = input.readI32();
                        _args.product = value_6;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_7: string = input.readString();
                        _args.firebaseUserIdFromKeychain = value_7;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.deviceId !== undefined && _args.firebaseIDToken !== undefined && _args.timestamp !== undefined) {
            return new TAuthenticateRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAuthenticateRequest from input");
        }
    }
}
export interface ITAuthenticateResponseArgs {
    userId: string;
    contact: PContact.TAppContact;
    refreshToken: string;
    accessToken: string;
    expiresAfter: number | Int64;
    customFirebaseToken: string;
    isReturningUser: boolean;
    hasImportedAccounts: boolean;
    verifiedPhone?: string;
}
export class TAuthenticateResponse {
    public userId: string;
    public contact: PContact.TAppContact;
    public refreshToken: string;
    public accessToken: string;
    public expiresAfter: Int64;
    public customFirebaseToken: string;
    public isReturningUser: boolean = false;
    public hasImportedAccounts: boolean = false;
    public verifiedPhone?: string;
    constructor(args: ITAuthenticateResponseArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
        if (args != null && args.contact != null) {
            this.contact = args.contact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contact] is unset!");
        }
        if (args != null && args.refreshToken != null) {
            this.refreshToken = args.refreshToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[refreshToken] is unset!");
        }
        if (args != null && args.accessToken != null) {
            this.accessToken = args.accessToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[accessToken] is unset!");
        }
        if (args != null && args.expiresAfter != null) {
            if (typeof args.expiresAfter === "number") {
                this.expiresAfter = new Int64(args.expiresAfter);
            }
            else {
                this.expiresAfter = args.expiresAfter;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[expiresAfter] is unset!");
        }
        if (args != null && args.customFirebaseToken != null) {
            this.customFirebaseToken = args.customFirebaseToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[customFirebaseToken] is unset!");
        }
        if (args != null && args.isReturningUser != null) {
            this.isReturningUser = args.isReturningUser;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[isReturningUser] is unset!");
        }
        if (args != null && args.hasImportedAccounts != null) {
            this.hasImportedAccounts = args.hasImportedAccounts;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[hasImportedAccounts] is unset!");
        }
        if (args != null && args.verifiedPhone != null) {
            this.verifiedPhone = args.verifiedPhone;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAuthenticateResponse");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.contact != null) {
            output.writeFieldBegin("contact", thrift.Thrift.Type.STRUCT, 2);
            this.contact.write(output);
            output.writeFieldEnd();
        }
        if (this.refreshToken != null) {
            output.writeFieldBegin("refreshToken", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.refreshToken);
            output.writeFieldEnd();
        }
        if (this.accessToken != null) {
            output.writeFieldBegin("accessToken", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.accessToken);
            output.writeFieldEnd();
        }
        if (this.expiresAfter != null) {
            output.writeFieldBegin("expiresAfter", thrift.Thrift.Type.I64, 5);
            output.writeI64(this.expiresAfter);
            output.writeFieldEnd();
        }
        if (this.customFirebaseToken != null) {
            output.writeFieldBegin("customFirebaseToken", thrift.Thrift.Type.STRING, 6);
            output.writeString(this.customFirebaseToken);
            output.writeFieldEnd();
        }
        if (this.isReturningUser != null) {
            output.writeFieldBegin("isReturningUser", thrift.Thrift.Type.BOOL, 7);
            output.writeBool(this.isReturningUser);
            output.writeFieldEnd();
        }
        if (this.hasImportedAccounts != null) {
            output.writeFieldBegin("hasImportedAccounts", thrift.Thrift.Type.BOOL, 8);
            output.writeBool(this.hasImportedAccounts);
            output.writeFieldEnd();
        }
        if (this.verifiedPhone != null) {
            output.writeFieldBegin("verifiedPhone", thrift.Thrift.Type.STRING, 9);
            output.writeString(this.verifiedPhone);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAuthenticateResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_8: string = input.readString();
                        _args.userId = value_8;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_9: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.contact = value_9;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_10: string = input.readString();
                        _args.refreshToken = value_10;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_11: string = input.readString();
                        _args.accessToken = value_11;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_12: Int64 = input.readI64();
                        _args.expiresAfter = value_12;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_13: string = input.readString();
                        _args.customFirebaseToken = value_13;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_14: boolean = input.readBool();
                        _args.isReturningUser = value_14;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_15: boolean = input.readBool();
                        _args.hasImportedAccounts = value_15;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 9:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_16: string = input.readString();
                        _args.verifiedPhone = value_16;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined && _args.contact !== undefined && _args.refreshToken !== undefined && _args.accessToken !== undefined && _args.expiresAfter !== undefined && _args.customFirebaseToken !== undefined && _args.isReturningUser !== undefined && _args.hasImportedAccounts !== undefined) {
            return new TAuthenticateResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAuthenticateResponse from input");
        }
    }
}
export interface ITRefetchAccessTokenRequestArgs {
    userId: string;
    deviceId: string;
    refreshToken: string;
    timestamp: number | Int64;
}
export class TRefetchAccessTokenRequest {
    public userId: string;
    public deviceId: string;
    public refreshToken: string;
    public timestamp: Int64;
    constructor(args: ITRefetchAccessTokenRequestArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
        if (args != null && args.deviceId != null) {
            this.deviceId = args.deviceId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[deviceId] is unset!");
        }
        if (args != null && args.refreshToken != null) {
            this.refreshToken = args.refreshToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[refreshToken] is unset!");
        }
        if (args != null && args.timestamp != null) {
            if (typeof args.timestamp === "number") {
                this.timestamp = new Int64(args.timestamp);
            }
            else {
                this.timestamp = args.timestamp;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[timestamp] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TRefetchAccessTokenRequest");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.deviceId != null) {
            output.writeFieldBegin("deviceId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.deviceId);
            output.writeFieldEnd();
        }
        if (this.refreshToken != null) {
            output.writeFieldBegin("refreshToken", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.refreshToken);
            output.writeFieldEnd();
        }
        if (this.timestamp != null) {
            output.writeFieldBegin("timestamp", thrift.Thrift.Type.I64, 4);
            output.writeI64(this.timestamp);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TRefetchAccessTokenRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_17: string = input.readString();
                        _args.userId = value_17;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_18: string = input.readString();
                        _args.deviceId = value_18;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_19: string = input.readString();
                        _args.refreshToken = value_19;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_20: Int64 = input.readI64();
                        _args.timestamp = value_20;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined && _args.deviceId !== undefined && _args.refreshToken !== undefined && _args.timestamp !== undefined) {
            return new TRefetchAccessTokenRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TRefetchAccessTokenRequest from input");
        }
    }
}
export interface ITRefetchAccessTokenResponseArgs {
    accessToken: string;
    expiresAfter: number | Int64;
    customFirebaseToken?: string;
    contact?: PContact.TAppContact;
    verifiedPhone?: string;
}
export class TRefetchAccessTokenResponse {
    public accessToken: string;
    public expiresAfter: Int64;
    public customFirebaseToken?: string;
    public contact?: PContact.TAppContact;
    public verifiedPhone?: string;
    constructor(args: ITRefetchAccessTokenResponseArgs) {
        if (args != null && args.accessToken != null) {
            this.accessToken = args.accessToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[accessToken] is unset!");
        }
        if (args != null && args.expiresAfter != null) {
            if (typeof args.expiresAfter === "number") {
                this.expiresAfter = new Int64(args.expiresAfter);
            }
            else {
                this.expiresAfter = args.expiresAfter;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[expiresAfter] is unset!");
        }
        if (args != null && args.customFirebaseToken != null) {
            this.customFirebaseToken = args.customFirebaseToken;
        }
        if (args != null && args.contact != null) {
            this.contact = args.contact;
        }
        if (args != null && args.verifiedPhone != null) {
            this.verifiedPhone = args.verifiedPhone;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TRefetchAccessTokenResponse");
        if (this.accessToken != null) {
            output.writeFieldBegin("accessToken", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.accessToken);
            output.writeFieldEnd();
        }
        if (this.expiresAfter != null) {
            output.writeFieldBegin("expiresAfter", thrift.Thrift.Type.I64, 2);
            output.writeI64(this.expiresAfter);
            output.writeFieldEnd();
        }
        if (this.customFirebaseToken != null) {
            output.writeFieldBegin("customFirebaseToken", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.customFirebaseToken);
            output.writeFieldEnd();
        }
        if (this.contact != null) {
            output.writeFieldBegin("contact", thrift.Thrift.Type.STRUCT, 4);
            this.contact.write(output);
            output.writeFieldEnd();
        }
        if (this.verifiedPhone != null) {
            output.writeFieldBegin("verifiedPhone", thrift.Thrift.Type.STRING, 5);
            output.writeString(this.verifiedPhone);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TRefetchAccessTokenResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_21: string = input.readString();
                        _args.accessToken = value_21;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_22: Int64 = input.readI64();
                        _args.expiresAfter = value_22;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_23: string = input.readString();
                        _args.customFirebaseToken = value_23;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_24: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.contact = value_24;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_25: string = input.readString();
                        _args.verifiedPhone = value_25;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.accessToken !== undefined && _args.expiresAfter !== undefined) {
            return new TRefetchAccessTokenResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TRefetchAccessTokenResponse from input");
        }
    }
}
export interface ITAuthenticateEmailRequestArgs {
    email: string;
    timestamp: number | Int64;
    signature: string;
}
export class TAuthenticateEmailRequest {
    public email: string;
    public timestamp: Int64;
    public signature: string;
    constructor(args: ITAuthenticateEmailRequestArgs) {
        if (args != null && args.email != null) {
            this.email = args.email;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[email] is unset!");
        }
        if (args != null && args.timestamp != null) {
            if (typeof args.timestamp === "number") {
                this.timestamp = new Int64(args.timestamp);
            }
            else {
                this.timestamp = args.timestamp;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[timestamp] is unset!");
        }
        if (args != null && args.signature != null) {
            this.signature = args.signature;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[signature] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAuthenticateEmailRequest");
        if (this.email != null) {
            output.writeFieldBegin("email", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.email);
            output.writeFieldEnd();
        }
        if (this.timestamp != null) {
            output.writeFieldBegin("timestamp", thrift.Thrift.Type.I64, 2);
            output.writeI64(this.timestamp);
            output.writeFieldEnd();
        }
        if (this.signature != null) {
            output.writeFieldBegin("signature", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.signature);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAuthenticateEmailRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_26: string = input.readString();
                        _args.email = value_26;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_27: Int64 = input.readI64();
                        _args.timestamp = value_27;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_28: string = input.readString();
                        _args.signature = value_28;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.email !== undefined && _args.timestamp !== undefined && _args.signature !== undefined) {
            return new TAuthenticateEmailRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAuthenticateEmailRequest from input");
        }
    }
}
export interface ITAuthenticateEmailResponseArgs {
    userId: string;
    accessToken: string;
    expiresAfter: number | Int64;
    sendToDashboard?: boolean;
}
export class TAuthenticateEmailResponse {
    public userId: string;
    public accessToken: string;
    public expiresAfter: Int64;
    public sendToDashboard?: boolean;
    constructor(args: ITAuthenticateEmailResponseArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
        if (args != null && args.accessToken != null) {
            this.accessToken = args.accessToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[accessToken] is unset!");
        }
        if (args != null && args.expiresAfter != null) {
            if (typeof args.expiresAfter === "number") {
                this.expiresAfter = new Int64(args.expiresAfter);
            }
            else {
                this.expiresAfter = args.expiresAfter;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[expiresAfter] is unset!");
        }
        if (args != null && args.sendToDashboard != null) {
            this.sendToDashboard = args.sendToDashboard;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAuthenticateEmailResponse");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.accessToken != null) {
            output.writeFieldBegin("accessToken", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.accessToken);
            output.writeFieldEnd();
        }
        if (this.expiresAfter != null) {
            output.writeFieldBegin("expiresAfter", thrift.Thrift.Type.I64, 3);
            output.writeI64(this.expiresAfter);
            output.writeFieldEnd();
        }
        if (this.sendToDashboard != null) {
            output.writeFieldBegin("sendToDashboard", thrift.Thrift.Type.BOOL, 4);
            output.writeBool(this.sendToDashboard);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAuthenticateEmailResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_29: string = input.readString();
                        _args.userId = value_29;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_30: string = input.readString();
                        _args.accessToken = value_30;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_31: Int64 = input.readI64();
                        _args.expiresAfter = value_31;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_32: boolean = input.readBool();
                        _args.sendToDashboard = value_32;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined && _args.accessToken !== undefined && _args.expiresAfter !== undefined) {
            return new TAuthenticateEmailResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAuthenticateEmailResponse from input");
        }
    }
}
export interface ITAuthenticateRaterRequestArgs {
    timestamp: number | Int64;
    oauthToken: string;
}
export class TAuthenticateRaterRequest {
    public timestamp: Int64;
    public oauthToken: string;
    constructor(args: ITAuthenticateRaterRequestArgs) {
        if (args != null && args.timestamp != null) {
            if (typeof args.timestamp === "number") {
                this.timestamp = new Int64(args.timestamp);
            }
            else {
                this.timestamp = args.timestamp;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[timestamp] is unset!");
        }
        if (args != null && args.oauthToken != null) {
            this.oauthToken = args.oauthToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[oauthToken] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAuthenticateRaterRequest");
        if (this.timestamp != null) {
            output.writeFieldBegin("timestamp", thrift.Thrift.Type.I64, 1);
            output.writeI64(this.timestamp);
            output.writeFieldEnd();
        }
        if (this.oauthToken != null) {
            output.writeFieldBegin("oauthToken", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.oauthToken);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAuthenticateRaterRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_33: Int64 = input.readI64();
                        _args.timestamp = value_33;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_34: string = input.readString();
                        _args.oauthToken = value_34;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.timestamp !== undefined && _args.oauthToken !== undefined) {
            return new TAuthenticateRaterRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAuthenticateRaterRequest from input");
        }
    }
}
export interface ITAuthenticateRaterResponseArgs {
    raterId: string;
    accessToken: string;
    expiresAfter: number | Int64;
}
export class TAuthenticateRaterResponse {
    public raterId: string;
    public accessToken: string;
    public expiresAfter: Int64;
    constructor(args: ITAuthenticateRaterResponseArgs) {
        if (args != null && args.raterId != null) {
            this.raterId = args.raterId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[raterId] is unset!");
        }
        if (args != null && args.accessToken != null) {
            this.accessToken = args.accessToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[accessToken] is unset!");
        }
        if (args != null && args.expiresAfter != null) {
            if (typeof args.expiresAfter === "number") {
                this.expiresAfter = new Int64(args.expiresAfter);
            }
            else {
                this.expiresAfter = args.expiresAfter;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[expiresAfter] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAuthenticateRaterResponse");
        if (this.raterId != null) {
            output.writeFieldBegin("raterId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.raterId);
            output.writeFieldEnd();
        }
        if (this.accessToken != null) {
            output.writeFieldBegin("accessToken", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.accessToken);
            output.writeFieldEnd();
        }
        if (this.expiresAfter != null) {
            output.writeFieldBegin("expiresAfter", thrift.Thrift.Type.I64, 3);
            output.writeI64(this.expiresAfter);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAuthenticateRaterResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_35: string = input.readString();
                        _args.raterId = value_35;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_36: string = input.readString();
                        _args.accessToken = value_36;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_37: Int64 = input.readI64();
                        _args.expiresAfter = value_37;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.raterId !== undefined && _args.accessToken !== undefined && _args.expiresAfter !== undefined) {
            return new TAuthenticateRaterResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAuthenticateRaterResponse from input");
        }
    }
}
export interface ITSendEmailVerificationRequestArgs {
    email: string;
}
export class TSendEmailVerificationRequest {
    public email: string;
    constructor(args: ITSendEmailVerificationRequestArgs) {
        if (args != null && args.email != null) {
            this.email = args.email;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[email] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TSendEmailVerificationRequest");
        if (this.email != null) {
            output.writeFieldBegin("email", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.email);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TSendEmailVerificationRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_38: string = input.readString();
                        _args.email = value_38;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.email !== undefined) {
            return new TSendEmailVerificationRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TSendEmailVerificationRequest from input");
        }
    }
}
export interface ITSendEmailVerificationResponseArgs {
}
export class TSendEmailVerificationResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TSendEmailVerificationResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TSendEmailVerificationResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TSendEmailVerificationResponse();
    }
}
export interface ITObjectIdArgs {
    value?: string;
}
export class TObjectId {
    public value?: string;
    constructor(args?: ITObjectIdArgs) {
        if (args != null && args.value != null) {
            this.value = args.value;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TObjectId");
        if (this.value != null) {
            output.writeFieldBegin("value", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.value);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TObjectId {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_39: string = input.readString();
                        _args.value = value_39;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TObjectId(_args);
    }
}
export interface ITWebAuthenticateRequestArgs {
    phoneNumber: string;
    authRequestId: string;
    serverEditSeqId?: TObjectId;
    status?: TWebAuthRequestStatus;
}
export class TWebAuthenticateRequest {
    public phoneNumber: string;
    public authRequestId: string;
    public serverEditSeqId?: TObjectId;
    public status?: TWebAuthRequestStatus;
    constructor(args: ITWebAuthenticateRequestArgs) {
        if (args != null && args.phoneNumber != null) {
            this.phoneNumber = args.phoneNumber;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[phoneNumber] is unset!");
        }
        if (args != null && args.authRequestId != null) {
            this.authRequestId = args.authRequestId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[authRequestId] is unset!");
        }
        if (args != null && args.serverEditSeqId != null) {
            this.serverEditSeqId = args.serverEditSeqId;
        }
        if (args != null && args.status != null) {
            this.status = args.status;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TWebAuthenticateRequest");
        if (this.phoneNumber != null) {
            output.writeFieldBegin("phoneNumber", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.phoneNumber);
            output.writeFieldEnd();
        }
        if (this.authRequestId != null) {
            output.writeFieldBegin("authRequestId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.authRequestId);
            output.writeFieldEnd();
        }
        if (this.serverEditSeqId != null) {
            output.writeFieldBegin("serverEditSeqId", thrift.Thrift.Type.STRUCT, 3);
            this.serverEditSeqId.write(output);
            output.writeFieldEnd();
        }
        if (this.status != null) {
            output.writeFieldBegin("status", thrift.Thrift.Type.I32, 4);
            output.writeI32(this.status);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TWebAuthenticateRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_40: string = input.readString();
                        _args.phoneNumber = value_40;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_41: string = input.readString();
                        _args.authRequestId = value_41;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_42: TObjectId = TObjectId.read(input);
                        _args.serverEditSeqId = value_42;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_43: TWebAuthRequestStatus = input.readI32();
                        _args.status = value_43;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.phoneNumber !== undefined && _args.authRequestId !== undefined) {
            return new TWebAuthenticateRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TWebAuthenticateRequest from input");
        }
    }
}
export interface ITActiveWebAuthResponseArgs {
    request?: TWebAuthenticateRequest;
}
export class TActiveWebAuthResponse {
    public request?: TWebAuthenticateRequest;
    constructor(args?: ITActiveWebAuthResponseArgs) {
        if (args != null && args.request != null) {
            this.request = args.request;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TActiveWebAuthResponse");
        if (this.request != null) {
            output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 1);
            this.request.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TActiveWebAuthResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_44: TWebAuthenticateRequest = TWebAuthenticateRequest.read(input);
                        _args.request = value_44;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TActiveWebAuthResponse(_args);
    }
}
export interface ITWebAuthenticateUpdateRequestArgs {
    authRequestId: string;
    status: TWebAuthRequestStatus;
}
export class TWebAuthenticateUpdateRequest {
    public authRequestId: string;
    public status: TWebAuthRequestStatus;
    constructor(args: ITWebAuthenticateUpdateRequestArgs) {
        if (args != null && args.authRequestId != null) {
            this.authRequestId = args.authRequestId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[authRequestId] is unset!");
        }
        if (args != null && args.status != null) {
            this.status = args.status;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[status] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TWebAuthenticateUpdateRequest");
        if (this.authRequestId != null) {
            output.writeFieldBegin("authRequestId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.authRequestId);
            output.writeFieldEnd();
        }
        if (this.status != null) {
            output.writeFieldBegin("status", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.status);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TWebAuthenticateUpdateRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_45: string = input.readString();
                        _args.authRequestId = value_45;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_46: TWebAuthRequestStatus = input.readI32();
                        _args.status = value_46;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.authRequestId !== undefined && _args.status !== undefined) {
            return new TWebAuthenticateUpdateRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TWebAuthenticateUpdateRequest from input");
        }
    }
}
export interface ITWebAuthenticateUpdateResponseArgs {
}
export class TWebAuthenticateUpdateResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TWebAuthenticateUpdateResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TWebAuthenticateUpdateResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TWebAuthenticateUpdateResponse();
    }
}
export interface ITWebAuthenticateResponseArgs {
    userId: string;
    contactId: string;
    accessToken: string;
    customFirebaseToken: string;
}
export class TWebAuthenticateResponse {
    public userId: string;
    public contactId: string;
    public accessToken: string;
    public customFirebaseToken: string;
    constructor(args: ITWebAuthenticateResponseArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contactId] is unset!");
        }
        if (args != null && args.accessToken != null) {
            this.accessToken = args.accessToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[accessToken] is unset!");
        }
        if (args != null && args.customFirebaseToken != null) {
            this.customFirebaseToken = args.customFirebaseToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[customFirebaseToken] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TWebAuthenticateResponse");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        if (this.accessToken != null) {
            output.writeFieldBegin("accessToken", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.accessToken);
            output.writeFieldEnd();
        }
        if (this.customFirebaseToken != null) {
            output.writeFieldBegin("customFirebaseToken", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.customFirebaseToken);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TWebAuthenticateResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_47: string = input.readString();
                        _args.userId = value_47;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_48: string = input.readString();
                        _args.contactId = value_48;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_49: string = input.readString();
                        _args.accessToken = value_49;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_50: string = input.readString();
                        _args.customFirebaseToken = value_50;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined && _args.contactId !== undefined && _args.accessToken !== undefined && _args.customFirebaseToken !== undefined) {
            return new TWebAuthenticateResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TWebAuthenticateResponse from input");
        }
    }
}
export interface ITWebAuthenticateStatusResponseArgs {
    status: TWebAuthRequestStatus;
    authResponse?: TWebAuthenticateResponse;
}
export class TWebAuthenticateStatusResponse {
    public status: TWebAuthRequestStatus;
    public authResponse?: TWebAuthenticateResponse;
    constructor(args: ITWebAuthenticateStatusResponseArgs) {
        if (args != null && args.status != null) {
            this.status = args.status;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[status] is unset!");
        }
        if (args != null && args.authResponse != null) {
            this.authResponse = args.authResponse;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TWebAuthenticateStatusResponse");
        if (this.status != null) {
            output.writeFieldBegin("status", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.status);
            output.writeFieldEnd();
        }
        if (this.authResponse != null) {
            output.writeFieldBegin("authResponse", thrift.Thrift.Type.STRUCT, 2);
            this.authResponse.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TWebAuthenticateStatusResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_51: TWebAuthRequestStatus = input.readI32();
                        _args.status = value_51;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_52: TWebAuthenticateResponse = TWebAuthenticateResponse.read(input);
                        _args.authResponse = value_52;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.status !== undefined) {
            return new TWebAuthenticateStatusResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TWebAuthenticateStatusResponse from input");
        }
    }
}
export interface ITUserIdArgs {
    userId: string;
}
export class TUserId {
    public userId: string;
    constructor(args: ITUserIdArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUserId");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUserId {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_53: string = input.readString();
                        _args.userId = value_53;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined) {
            return new TUserId(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TUserId from input");
        }
    }
}
export interface ITInviteRequestArgs {
    phoneNumber: string;
}
export class TInviteRequest {
    public phoneNumber: string;
    constructor(args: ITInviteRequestArgs) {
        if (args != null && args.phoneNumber != null) {
            this.phoneNumber = args.phoneNumber;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[phoneNumber] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TInviteRequest");
        if (this.phoneNumber != null) {
            output.writeFieldBegin("phoneNumber", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.phoneNumber);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TInviteRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_54: string = input.readString();
                        _args.phoneNumber = value_54;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.phoneNumber !== undefined) {
            return new TInviteRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TInviteRequest from input");
        }
    }
}
export interface ITInviteResponseArgs {
}
export class TInviteResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TInviteResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TInviteResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TInviteResponse();
    }
}
export interface ITAuthenticateHeliosOrderDashboardLoginRequestArgs {
    oauthToken: string;
}
export class TAuthenticateHeliosOrderDashboardLoginRequest {
    public oauthToken: string;
    constructor(args: ITAuthenticateHeliosOrderDashboardLoginRequestArgs) {
        if (args != null && args.oauthToken != null) {
            this.oauthToken = args.oauthToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[oauthToken] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAuthenticateHeliosOrderDashboardLoginRequest");
        if (this.oauthToken != null) {
            output.writeFieldBegin("oauthToken", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.oauthToken);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAuthenticateHeliosOrderDashboardLoginRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_55: string = input.readString();
                        _args.oauthToken = value_55;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.oauthToken !== undefined) {
            return new TAuthenticateHeliosOrderDashboardLoginRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAuthenticateHeliosOrderDashboardLoginRequest from input");
        }
    }
}
export interface ITAuthenticateHeliosOrderDashboardLoginResponseArgs {
    raterId: string;
    accessToken: string;
    expiresAfter: number | Int64;
}
export class TAuthenticateHeliosOrderDashboardLoginResponse {
    public raterId: string;
    public accessToken: string;
    public expiresAfter: Int64;
    constructor(args: ITAuthenticateHeliosOrderDashboardLoginResponseArgs) {
        if (args != null && args.raterId != null) {
            this.raterId = args.raterId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[raterId] is unset!");
        }
        if (args != null && args.accessToken != null) {
            this.accessToken = args.accessToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[accessToken] is unset!");
        }
        if (args != null && args.expiresAfter != null) {
            if (typeof args.expiresAfter === "number") {
                this.expiresAfter = new Int64(args.expiresAfter);
            }
            else {
                this.expiresAfter = args.expiresAfter;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[expiresAfter] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAuthenticateHeliosOrderDashboardLoginResponse");
        if (this.raterId != null) {
            output.writeFieldBegin("raterId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.raterId);
            output.writeFieldEnd();
        }
        if (this.accessToken != null) {
            output.writeFieldBegin("accessToken", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.accessToken);
            output.writeFieldEnd();
        }
        if (this.expiresAfter != null) {
            output.writeFieldBegin("expiresAfter", thrift.Thrift.Type.I64, 3);
            output.writeI64(this.expiresAfter);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAuthenticateHeliosOrderDashboardLoginResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_56: string = input.readString();
                        _args.raterId = value_56;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_57: string = input.readString();
                        _args.accessToken = value_57;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_58: Int64 = input.readI64();
                        _args.expiresAfter = value_58;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.raterId !== undefined && _args.accessToken !== undefined && _args.expiresAfter !== undefined) {
            return new TAuthenticateHeliosOrderDashboardLoginResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAuthenticateHeliosOrderDashboardLoginResponse from input");
        }
    }
}
